import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const Wrapper = styled.div`
  max-width: 340px;
`;

const BottomButtons = styled.div`
  margin-top: ${tokens.spacer.x3};

  button,
  span {
    width: 100%;
    text-align: center;
  }
`;

const Title = styled.h2`
  ${tokens.text('header3')};
  margin-bottom: ${tokens.spacer.x2};
`;

const Description = styled.div`
  ${tokens.text('body1')};
`;

export const MfaEnforceLandingPageStyle = { Wrapper, BottomButtons, Title, Description };
